<template>
  <div class="navigtorPage">
    <div class="navigation mainBody">
      <router-link to="aboutUs">
        <div class="logo">
          <img v-if="scrollDistance < 150 && isAbout === 'true'" src="@/assets/PC/navigtor/logo-white.png" alt="">
          <img v-else src="@/assets/PC/navigtor/logo-black.png" alt="">
        </div>
      </router-link>
      <el-tabs v-model="pageName" @tab-click="changeTab">
        <el-tab-pane name="aboutUs">
          <template slot="label">
            <span>{{$t("nav.aboutUs")}}</span>
          </template>
        </el-tab-pane>
        <el-tab-pane name="fundProduct">
          <template slot="label">
            <span>{{$t("nav.fundProduct")}}</span>
          </template>
        </el-tab-pane>
        <el-tab-pane name="news">
          <template slot="label">
            <span>{{$t("nav.news")}}</span>
          </template>
        </el-tab-pane>
        <el-tab-pane name="investorInteraction">
          <template slot="label">
            <span>{{$t("nav.investorInteraction")}}</span>
          </template>
        </el-tab-pane>
        <el-tab-pane name="contactUs">
          <template slot="label">
            <span>{{$t("nav.contactUs")}}</span>
          </template>
        </el-tab-pane>
      </el-tabs>
       <!-- v-if="!isAboutUs" -->
      <el-select v-if="!isAboutUs" v-model="language" @change="changeLang">
        <el-option
          v-for="(item, index) in langList"
          :key="index"
          :label="item.label"
          :value="item.value">
        </el-option>
      </el-select>
      <div class="navSelect" v-if="isAboutUs">
        <el-select :popper-append-to-body="false" class="navSelect" v-model="language" @change="changeLang">
          <el-option
            v-for="(item, index) in langList"
            :key="index"
            :label="item.label"
            :value="item.value">
          </el-option>
        </el-select>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'navigtorPage',
  data () {
    return {
      pageName: '',
      scrollDistance: 0,
      isAbout: localStorage.getItem('isAbout'),
      language: 'EN',
      langList: [
        {
          label: 'EN',
          value: 'en'
        },
        {
          label: '简体',
          value: 'zh'
        }
      ],
      isAboutUs: false
    }
  },
  created () {
    this.pageName = this.$route.name
    //  处理语言
    if (localStorage.getItem('lang')) {
      this.language = localStorage.getItem('lang')
      this.$i18n.locale = localStorage.getItem('lang')
    }
  },
  mounted () {
    if (this.$route.name === 'aboutUs') {
      this.isAboutUs = true
      window.addEventListener('scroll', this.handleScroll)
    } else {
      this.$nextTick(() => {
        this.changeColor()
      })
    }
  },
  beforeDestroy () {
    // 移除滚动事件监听器
    window.removeEventListener('scroll', this.handleScroll)
  },
  methods: {
    changeTab (e) {
      // 只有点击的不是当前页面才进行跳转，否则默认回到顶部
      if (this.$route.name !== e.name) {
        this.pageName = e.name
        this.$router.replace({ name: e.name })
      }
      window.scrollTo(0, 0)
    },
    changeLang (e) {
      this.langList.forEach(item => {
        if (item.value === e) {
          localStorage.setItem('lang', item.value)
        }
      })
      this.$i18n.locale = e
    },
    handleScroll () {
      this.scrollDistance = window.scrollY || document.documentElement.scrollTop
      const nav = document.querySelector('.navigtorPage')
      const tabItem = document.querySelectorAll('.el-tabs__item')
      if (this.scrollDistance > 150) {
        nav.style.backgroundColor = '#fff'
        this.isAboutUs = false
        tabItem.forEach(item => {
          item.style.color = '#1D2129'
        })
      } else {
        this.isAboutUs = true
        nav.style.backgroundColor = ''
        tabItem.forEach(item => {
          item.style.color = '#fff'
        })
      }
    },
    changeColor () {
      const nav = document.querySelector('.navigtorPage')
      const tabItem = document.querySelectorAll('.el-tabs__item')
      nav.style.backgroundColor = '#fff'
      tabItem.forEach(item => {
        item.style.color = '#1D2129'
      })
    }
  }
}
</script>

<style scoped lang="less">
.navigtorPage {
  width: 100%;
  position: fixed;
  top: 0;
  z-index: 999;
  box-shadow: 0px 1px 8px 0px rgba(0,0,0,0.12);
  // background-color: #fff;
}
.navigation {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 0.2rem;
  .logo {
    height: 1rem;
    display: flex;
    align-items: center;
    img {
      width: 2.46rem;
      height: 0.56rem;
    }
  }
  .el-tabs {
    margin-left: 0.4rem;
  }
}
/deep/ .el-tabs__item {
  font-size: 0.36rem;
  font-weight: 400;
  color: #FFFFFF;
}
/deep/ .el-tabs__header {
  margin: 0;
}
/deep/ .el-tabs__nav {
  height: 1rem;
  display: flex;
  align-items: center;
  justify-content: center;
}
// 整体的白线
/deep/ .el-tabs__nav-wrap::after {
  content: none;
}
// 选中的字体颜色
/deep/ .el-tabs__item.is-active {
  color: #C91818 !important;
}
// 选中的底部线条
/deep/ .el-tabs__active-bar {
  background-color: #C91818;
  height: 0.08rem !important;
}
// 字体的hover
/deep/ .el-tabs__item:hover {
  color: #ADB2BB !important;
}
.el-select {
  width: 2.2rem;
}
/deep/ .el-input__inner {
  border: 1px solid #1D2129;
}
/deep/ .el-select .el-input__inner:focus {
  border-color: #C91818;
}
/deep/ .el-select .el-input .el-select__caret {
  font-weight: 400;
  color: #383b41;
}
/deep/ .el-input__inner {
  color: #1D2129;
  font-size: 14px;
  font-weight: 400;
}
.el-select-dropdown__item {
  padding: 0.12rem 0.4rem;
  font-weight: 400;
  display: flex;
  align-items: center;
  font-size: 0.28rem !important;
}
.el-select-dropdown__item.selected {
  color: #C91818;
}
.navSelect {
  height: 1.8rem;
  /deep/ .el-input__inner {
    border: 1px solid #FFFFFF;
    color: #FFFFFF;
    background-color: rgba(0, 0, 0, 0);
    &:hover {
      border: 1px solid #ADB2BB;
    }
  }
  /deep/ .el-select .el-input .el-select__caret {
    color: #fff;
    font-weight: 700;
  }
  /deep/ .el-select-dropdown {
    background-color: rgba(0, 0, 0, 0) !important;
  }
  .el-select-dropdown__item {
    color: #fff;
  }
  .el-select-dropdown__item.hover {
    background-color: #A54545;
  }
}
</style>
<style lang="less">
.el-popper .popper__arrow {
  display: none !important;
}
</style>
